import { Button, Modal, Space, InputNumber } from "antd";
import React, { useState } from "react";
import { EditFilled } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export const FoilPopup = (props) => {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [costs, setCosts] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setCosts(props.costs);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setCosts(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "foil", props.id);
      await updateDoc(ref, {
         costs: costs,
         id: props.id,
      })
         .then(() => {
            setIsModalOpen(true);
            setCosts(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={700} title={"Color :" + props.title} open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber addonBefore="Costs :" value={costs} style={{ width: "100%" }} onChange={(value) => setCosts(value)} />
            </Space>
         </Modal>
      </>
   );
};
